import { useCallback } from 'react'

import { Layout } from '@loadsmart/miranda-react'

import type { Shipment } from '../../domain/Shipment'
import { AssetCarrierSelector } from '../AssetCarrierSelector'
import DriverSelector from '../DriverSelector'
import LoadSetup from '../LoadSetup'
import TruckSelector from '../TruckSelector'

type TrackingVisibilityCardProps = {
  readonly shipment: Shipment
  readonly refetchShipment: (uuid: string) => Promise<void>
}

/**
 * This component is a legacy version and will be removed along with
 * the enableNewTrackingVisibilty feature flag.
 *
 * @deprecated
 */
export function LegacyTrackingVisibilityCard({
  shipment,
  refetchShipment,
}: TrackingVisibilityCardProps) {
  const enableAssetSelector = shipment.carrier.entityType === 'broker'

  const refetchShipmentDetails = useCallback(() => {
    refetchShipment(shipment.uuid)
  }, [refetchShipment, shipment.uuid])

  return (
    <LoadSetup>
      <Layout.Stack gap="spacing-3">
        {enableAssetSelector && (
          <AssetCarrierSelector
            effectiveCarrier={shipment.effectiveCarrier}
            shipmentUUID={shipment.uuid}
            onAssignAssetCarrier={refetchShipmentDetails}
          />
        )}
        <DriverSelector
          shipmentUUID={shipment.uuid}
          carrierUUID={shipment.carrier.uuid}
          driver={shipment.driver}
          onAssignDriver={refetchShipmentDetails}
        />
        <TruckSelector
          carrierUUID={shipment.carrier.uuid}
          shipmentUUID={shipment.uuid}
          tractorNumber={shipment.tractorNumber}
          onAssignTruck={refetchShipmentDetails}
        />
      </Layout.Stack>
    </LoadSetup>
  )
}
